module.exports = __webpack_public_path__ + "img/icon_patent_es.ccf3a0fa.png";